import React from 'react';
import { Feed, Icon, Label, List, Image } from 'semantic-ui-react';

const ExperienceItem = (props) => {
    return (
        <Feed.Event>
            <Feed.Label style={{ lineHeight: 4, width: '25%' }}>
                <Label basic color='blue' pointing='right'>
                    {props.start} - {props.end}
                </Label>
            </Feed.Label>
            <Feed.Content>
                <Feed.Summary>
                    <h3 style={{margin: '4px 0'}}>{props.position}</h3>
                    <Image src={props.logo} size='tiny' style={{ height: '1.75em' }} verticalAlign='middle' /> <a style={{ fontSize: "1.125em" }} href={props.url} target="_blank">{props.company.toLowerCase()}</a>
                    <div className="text-muted">{props.location}</div>
                </Feed.Summary>
                <Feed.Extra text>
                    <List size={"small"}>
                    {(() => {
                        return props.description.map((line, key) => {
                            return (
                                <List.Item key={key}>
                                    <Icon size={"small"} name='right triangle' />
                                    <List.Content>
                                        {line}
                                    </List.Content>
                                </List.Item>
                            );
                        });
                    })()}
                    </List>
                </Feed.Extra>
            </Feed.Content>
        </Feed.Event>
    );
}

export default ExperienceItem;


// WEBPACK FOOTER //
// ./src/components/ExperienceItem.js